import HeaderContractDetail from './HeaderContractDetail';

export default HeaderContractDetail;